<template>
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none">
        <path
            d="M1.12842 12.25C1.12842 13.075 1.80342 13.75 2.62842 13.75H8.62842C9.45342 13.75 10.1284 13.075 10.1284 12.25V3.25H1.12842V12.25ZM2.62842 4.75H8.62842V12.25H2.62842V4.75ZM8.25342 1L7.50342 0.25H3.75342L3.00342 1H0.378418V2.5H10.8784V1H8.25342Z"
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    name: 'Trash',
    props: {
        color: {
            type: String,
            default: '#A1A8AF',
        },
    },
}
</script>

<style></style>
